import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';

import styles from '../../css/components/content/foe-stellar-age.css';


function FoeStellarAgeHeader() {

	const { t } = useTranslation('translation');
	const onelpsParams = useContext(OneLPSsdkParamsContext);

	const {
		textTranslationKey: textKey,
		titleTranslationKey: titleKey,
		titleHighlightTranslationKey: titleHighlightKey,
		subtitleTranslationKey: subtitleKey,
	} = onelpsParams.stellarAgeHeader ?? {};

	return (
		<div className={styles.stellarAgeHeader}>
			<p
				data-translation-key={textKey}
				className={styles.tagline}>
				{t(textKey)}
			</p>
			<h1
				data-translation-key={titleKey}
				className={styles.title}
			>
				{t(titleKey)}
				<br/>
				<span
					className={styles.titleHighlight}
					data-translation-key={titleHighlightKey}
				>{t(titleHighlightKey)}
				</span>
			</h1>
			<h2
				data-translation-key={subtitleKey}
				className={styles.subtitle}
			>
				{t(subtitleKey)}
			</h2>
		</div>
	);
}

export default FoeStellarAgeHeader;
